import React from 'react'
import { EB_PRODUCT_NAME } from '@chegg-wt/core/constants/site'
import MyAccount from '@chegg-wt/core/components/MyAccount'
import Nav from '@chegg-wt/core/components/Nav'
import { useOnUnloadTimeOnPage } from '@chegg/time-on-page'
import { navItemsSelector } from '../config/nav'

const AppAccount = () => {
  useOnUnloadTimeOnPage()
  return (
    <>
      <Nav navItemsSelector={navItemsSelector} />
      <MyAccount siteName={EB_PRODUCT_NAME} />
    </>
  )
}

export default AppAccount
